import { useTranslation } from "react-i18next";

import { Group, Text } from "@mantine/core";

import { useFormatters } from "@prostocheck/i18n";

import { ReceiptsTable } from "../receipts-table";
import { IReceiptsPanelProps } from "./receipts-panel.models";

export const ReceiptsPanel = ({
  receipts,
  range,
  onSelectReceipt,
}: IReceiptsPanelProps) => {
  const { t } = useTranslation();
  const { formatDate } = useFormatters();

  return (
    <div>
      {/* `mih` matches the secondary button's height so this row is the same
          height as the Z-reports tab's (which adds a "Періодичний звіт"
          button here) — otherwise switching tabs shifts the table below. */}
      <Group align="center" mih="2.75rem" mb="md">
        <Text size="sm" c="dimmed">
          {t("register.periodRange", {
            from: formatDate(range.from),
            to: formatDate(range.to),
          })}
        </Text>
      </Group>

      <ReceiptsTable receipts={receipts} onSelectReceipt={onSelectReceipt} />
    </div>
  );
};
